module.exports = __webpack_public_path__ + "static/media/footer-logo.8044cfcc.svg";